import React from 'react';
import classes from './Checkbox.module.css';
import PropTypes from 'prop-types';

const Checkbox = ({ value, setValue, label, disabled, labelStyle, className = '' }) => {
  const isArrayValue = Array.isArray(value);
  const checkedIndex = isArrayValue ? value?.indexOf(label) ?? -1 : -1;
  const isChecked = isArrayValue ? checkedIndex !== -1 : value === label;

  const handleClick = () => {
    let newValue;
    if (isArrayValue) {
      const updatedValues = Array.isArray(value) ? value.slice() : [];
      if (isChecked) {
        updatedValues.splice(checkedIndex, 1);
      } else {
        updatedValues.push(label);
      }
      newValue = updatedValues;
    } else {
      newValue = isChecked ? '' : label;
    }
    setValue(newValue);
  };

  return (
    <>
      <style>{`
        .${classes.container} input:disabled ~ .${classes.checkmark} {
          border: ${isChecked ? 0 : 2}px solid #4d4d4d;
          background-color: ${isChecked ? 'green' : 'transparent'};
        }
      `}</style>

      <div className={`my-2 ${classes.checkboxWithLabel} ${className}`}>
        <div className={`${classes.container}`}>
          <input type="checkbox" checked={isChecked} disabled={disabled} id={`checkbox${label}`} />
          <button
            type="button"
            className={classes.checkmark}
            onClick={handleClick}
            disabled={disabled}
            aria-pressed={isChecked}></button>
        </div>
        {label &&
          (() => {
            let labelClassName;
            if (isChecked && !disabled) {
              labelClassName = classes.labelChecked;
            } else if (disabled) {
              labelClassName = classes.labelDisabled;
            } else {
              labelClassName = classes.label;
            }

            return (
              <label
                htmlFor={`checkbox${label}`}
                className={` ${labelClassName}`}
                style={{
                  ...labelStyle
                }}>
                <span>{label}</span>
              </label>
            );
          })()}
      </div>
    </>
  );
};

Checkbox.propTypes = {
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  setValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelStyle: PropTypes.object,
  className: PropTypes.string
};
Checkbox.defaultProps = {
  value: [],
  disabled: false,
  label: null
};
export default Checkbox;
